import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SnackBarService } from 'src/app/shared';
import { NotificationService } from '../../services/notification.service';

@Component({
  selector: 'app-create-contact',
  templateUrl: './create-contact.component.html',
  styleUrls: ['./create-contact.component.scss']
})
export class CreateContactComponent implements OnInit {


  isEditingMode:boolean=false
  createContactForm:FormGroup=new FormGroup({})
  contactDetail:any
  contactId:any
  constructor(
    private activatedRoute : ActivatedRoute,
    private notificationService:NotificationService,
    private snackbarservice:SnackBarService,
    private router:Router
  ) { }

  ngOnInit(): void {
    this.initForm();
    this.setRouteParam();
  }

  initForm(){
    this.createContactForm=new FormGroup({
      name:new FormControl('',Validators.required),
      email:new FormControl('',[Validators.email,Validators.required])
    })

  }

  setRouteParam(){
    this.activatedRoute.params.subscribe(params=>{
      this.contactId=params.id ? params.id : ''
    })
    if(this.contactId){
      this.isEditingMode=true
      this.notificationService.getNotificationContactDetail(this.contactId).subscribe(data=>{
        this.contactDetail=data
        this.setContactData();
      })
    }
  }

  setContactData(){
    if(this.isEditingMode){
      this.createContactForm.controls.name.patchValue(this.contactDetail.name)
      this.createContactForm.controls.email.patchValue(this.contactDetail.email)
    }
  }

  createContact(){

    let params={
      name: this.createContactForm.get('name').value,
      email:this.createContactForm.get('email').value,
    }
    if(this.isEditingMode){
      this.notificationService.updateNotificationContact(this.contactId,params).subscribe(
        success=>{
        this.snackbarservice.showSnack('notification contact updated successfuly.')
        this.router.navigate(['/notifications/contacts'])
        },
        error=>{
          this.snackbarservice.showSnack(error.detail)
        }    
      )
    }
    else{
      this.notificationService.createNotificationContact(params).subscribe(
        success=>{
        this.snackbarservice.showSnack('notification contact created successfuly.')
        this.router.navigate(['/notifications/contacts'])
        },
        error=>{
          this.snackbarservice.showSnack(error.detail)
        }    
      )
    }
  }


}
